import { ValueModel } from '@kts-front/models';
import { Nullable } from '@kts-front/types';
import { reaction, when } from 'mobx';

import { projectsHandbookStore } from 'stores/global/RootStore';
import { searchFilterOptionEntity } from 'utils/searchFilterOptionEntity';

import { FieldSelectStore, FieldSelectStoreOptions } from '../form/FieldSelectStore';

type FieldSelectProjectStoreOptions = Omit<FieldSelectStoreOptions, 'getOptions' | 'searchDebounceTimeout'>;

export class FieldSelectProjectStore extends FieldSelectStore {
  readonly projectId = new ValueModel<Nullable<number>>(null);
  constructor(options: FieldSelectProjectStoreOptions) {
    super({
      ...options,
      searchDebounceTimeout: 0,
      getOptions: async ({ search, keys }) => {
        const keysSet = new Set(keys);

        // Ensure the store is loaded
        if (!projectsHandbookStore.loadingStage.isFinished) {
          await projectsHandbookStore.load();
        }

        const items = searchFilterOptionEntity(
          projectsHandbookStore.items.map((item) => ({
            key: item.id.toString(),
            value: item.name,
          })),
          search,
        ).filter(({ key }) => (keys.length ? keysSet.has(key) : true));

        return {
          isError: false,
          data: {
            items,
            total: items.length,
          },
        };
      },
    });

    when(
      () => projectsHandbookStore.loadingStage.isFinished,
      () => {
        this.load();
      },
    );

    // Автоматически выбираем проект по projectId
    reaction(
      () => this.projectId.value,
      async (projectId) => {
        if (projectId) {
          // Убеждаемся, что опции загружены перед установкой значения
          if (!projectsHandbookStore.loadingStage.isFinished) {
            await projectsHandbookStore.load();
          }
          await this.load();
          this.setValueByKey(projectId.toString());
        }
      },
    );
  }

  resetValue() {
    this.projectId.change(null);
    super.resetValue();
  }
}
